module.exports = __webpack_public_path__ + "85198cccf8aeaaebc833e53a50a405d6.svg";